import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

const DateRangeForm = ({ onSubmit }) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');


  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(startDate, endDate);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div>
        <Form.Label htmlFor="startDate">Start Date:</Form.Label>
        <Form.Control
          type="date"
          id="startDate"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          required
        />
      </div>
      <div class="mb-2">
        <Form.Label htmlFor="endDate">End Date:</Form.Label>
        <Form.Control
          type="date"
          id="endDate"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          required
        />
      </div>
      <Button type="submit">Submit</Button>
    </Form>
  );
};

export default DateRangeForm;